import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import SettingsTabs from '../../components/common/SettingsTabs';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
function SettingsOnboard() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        onboarding_admission_fee: '',
        onboarding_tax: '',
        default_currency: '',
        onboarding_service_charge: '',
    });
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cancel, setCancels] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const response = await apiService.postRequest(`/admin/get-protected-settings?settings_type=onboarding`);
                const generaldata = response.data;
                setFormData({
                    onboarding_admission_fee: generaldata.onboarding_admission_fee || '',
                    onboarding_service_charge: generaldata.onboarding_service_charge || '',
                    onboarding_tax: generaldata.onboarding_tax || '',
                    default_currency: generaldata.default_currency || '',
                });
            } catch (error) {
                console.error("Error fetching user data", error);
            }finally {
                setCancels(false)
                setLoading(false);
            }
        };

        fetchUserData();
    }, [cancel]);
        // Clear specific errors when inputs are modified
        const handleInputChange = (e) => {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
    
            // Clear the error for the changed field
            if (errors[name]) {
                setErrors({ ...errors, [name]: '' });
            }
        };
    
        // Basic validation logic
        // const validate = () => {
        //     const newErrors = {};
        //     if (!formData.onboarding_admission_fee) newErrors.onboarding_admission_fee = 'First name is required';
        //     if (!formData.site_url) newErrors.site_url = 'Last name is required';
        //     if (!formData.site_email) newErrors.site_email = 'Email is required';
        //     else if (!/\S+@\S+\.\S+/.test(formData.site_email)) newErrors.site_email = 'Email is invalid';
        //     if (!formData.site_phone) newErrors.site_phone = 'Phone number is required';
        //     else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.site_phone)) newErrors.site_phone = 'Phone number must be in the format (123) 456-7890';
        //     if (!formData.dob) newErrors.dob = 'Date of birth is required';
        //     if (!formData.password) newErrors.password = 'Password is required';
        //     if (!formData.password_confirmation) newErrors.password_confirmation = 'Please confirm your password';
        //     else if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Passwords do not match';
        //     if (formData.roles.length === 0) newErrors.roles = 'At least one Group is required';
    
        //     const password = formData.password;
        //     const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
        //     if (!passwordFormat.test(password)) {
        //         newErrors.password = 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and any one special character.';
        //     }
    
        //     const site_email = formData.site_email;
        //     const emailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        //     if (!emailFormat.test(site_email)) {
        //         newErrors.site_email = 'Please enter a valid site_email address.';
        //     }
    
        //     setErrors(newErrors);
        //     return Object.keys(newErrors).length === 0;
        // };
        
        const handleSubmit = async (e) => {
            e.preventDefault();
    
            const data = new FormData();
            data.append('onboarding_admission_fee', formData.onboarding_admission_fee);
            data.append('onboarding_service_charge', formData.onboarding_service_charge);
            data.append('onboarding_tax', formData.onboarding_tax);
            data.append('default_currency', formData.default_currency);
            
            // if (formData.site_logo) {
            // }
    
            setBtnLoading(true);
            try {
                const response = await apiService.postRequest('/admin/save-onboarding-settings', data);
                if (response && response.success === true) {
                    // navigate('/user/member');
                    toast(response.message || "Settings saved successfully!");
                } else {
                    setErrorMessage(response.message || "Failed. Please try again");
                    if (response.errors) {
                        setErrors(response.errors);
                    }
                    if(response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (error) {
                console.error('Error adding user:', error);
            } finally {
                setBtnLoading(false);
            }
        };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Company Settings</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Company Settings <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Onboarding</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn my-5">
                        <SettingsTabs/>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center">
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                            <Grid size={{sm:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Admission Fees<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="onboarding_admission_fee" value={formData.onboarding_admission_fee} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}/>
                                    {errors.onboarding_admission_fee && <p style={{color:"red"}}>{errors.onboarding_admission_fee}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Service Charge<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="onboarding_service_charge" value={formData.onboarding_service_charge} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}/>
                                    {errors.onboarding_service_charge && <p style={{color:"red"}}>{errors.onboarding_service_charge}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Tax<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="onboarding_tax" value={formData.onboarding_tax} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}/>
                                    {errors.onboarding_tax && <p style={{color:"red"}}>{errors.onboarding_tax}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Default Currency<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="default_currency" value={formData.default_currency} onChange={handleInputChange}/>
                                    {errors.default_currency && <p style={{color:"red"}}>{errors.default_currency}</p>}
                                </Grid>
                                {errorsmessage && <p style={{ color: 'red' }}>{errorsmessage}</p>}
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container className="gap-3 my-3">
                                <button type='button' className='registersendbtn1' onClick={()=>setCancels(true)}>Cancel</button>
                                <button type="submit" className='registersendbtn2'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </form>
                    </>}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default SettingsOnboard
